import { DataBean } from "../DataBean";

export class UBLAdminFee extends DataBean {

    public async deleteUBLAdminFee(idUBLAdminFee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteUBLAdminFee_Number", [idUBLAdminFee]);
    }

    public async getUBLAdminFee(idUBLAdminFee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLAdminFee_getUBLAdminFee_Number", [idUBLAdminFee]);
    }

    public async getUBLAdminFeeCatalog(regex: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getUBLAdminFeeCatalog_String_Number_Number", [regex, page, recordsPerPage]);
    }

    public async getUBLAdminFeeTypeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getUBLAdminFeeTypeConstants_Number", [arg]);
    }

    public async updateUBLAdminFee(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.ubl.UBLAdminFee_updateUBLAdminFee_com.quickdataerp.bean.ubl.UBLAdminFee", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.ubl.UBLAdminFee"
            }
        ]);
    }

}
